import { css } from 'lit';

export default css`
  .content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    gap: 50px;
  }

  .wave__container {
    width: 370px;
    height: 40px;
    position: relative;
    overflow: hidden;
  }

  .initial__wave {
    position: absolute;
    width: 100%;
    border-bottom: 1px dotted var(--amityeko-color-gray-3);
    top: 20px;
  }

  canvas {
    width: 100%;
    height: 100%;
    background-color: var(--amityeko-color-font-light);
  }

  .icon__wrapper {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 2px 2px 1px rgba(0, 0, 0, 0.07);
    cursor: pointer;
  }

  amityeko-tg-title {
    text-align: center;
  }

  amityeko-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80%;
    height: 80%;
    border-radius: 50%;
    box-shadow: 0px 0px 3px 3px rgba(0, 0, 0, 0.15);
  }
`;
